import React from "react";
import {
  SimpleForm,
  Edit,
  ArrayInput,
  SimpleFormIterator,
  DateInput,
  TextInput,
  SelectInput,
  ReferenceInput,
  NumberInput
} from "react-admin";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TodayIcon from "@material-ui/icons/Today";
import RoomIcon from "@material-ui/icons/Room";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import Star from "@material-ui/icons/Star";
import { styles } from "../../layout/Styles";

export const IngresoGrandesGeneradoresEditComponent  = (props) => {

    return (
      <Edit title="Editar Pesaje" {...props}>
        <SimpleForm redirect="/ingreso-grandes-generadores">
            <Grid container spacing={0}>
              <Grid item xs={12} md={4}>
              <Paper style={styles.paperIcon}>
                <Star style={styles.iconLeft} />
                <ReferenceInput
                  label="Predio"
                  reference="predios"
                  source="predio"
                  sort={{ field: 'nombre', order: 'ASC' }}
                >
                    <SelectInput optionText="nombre" optionValue="_id" fullWidth />
                </ReferenceInput>
              </Paper>
                <Paper style={styles.paperIcon}>
                  <TodayIcon style={styles.iconLeft} />
                  <div>
                    <DateInput label="Fecha" source="fecha" fullWidth />
                  </div>
                </Paper>
                <Paper style={styles.paperIcon}>
                  <RoomIcon style={styles.iconLeft} />
                  <div>
                    <ReferenceInput reference="etapas-grandes-generadores" source="etapa">
                      <SelectInput  optionText="nombre" optionValue="_id" fullWidth />
                    </ReferenceInput>
                  </div>
                </Paper>
                <Paper style={styles.paperIcon}>
                  <LocationCityIcon style={styles.iconLeft} />
                  <div>
                    <ReferenceInput reference="grandes-generadores" source="generador">
                      <SelectInput  optionText="nombre" optionValue="_id" fullWidth />
                    </ReferenceInput>
                  </div>
                </Paper>
                <Paper style={styles.paperIcon}>
                  <ShoppingBasketIcon style={styles.iconLeft} />
                  <div>
                    <ReferenceInput reference="operarios" source="operario">
                      <SelectInput  optionText="nombre" optionValue="_id" fullWidth />
                    </ReferenceInput>
                  </div>
                </Paper>
                <Paper style={styles.paperIcon}>
                  <LocalShippingIcon style={styles.iconLeft} />
                  <TextInput label="Patente" source="patente" fullWidth />
                </Paper>
              </Grid>
              <Grid item xs={12} md={8}>
                <Paper style={styles.paper} className="materiales">
                    <ArrayInput source="materiales">
                      <SimpleFormIterator>
                        <ReferenceInput reference="materiales" source="material">
                          <SelectInput  optionText="nombre" optionValue="_id" fullWidth />
                        </ReferenceInput>
                        <NumberInput label="Peso" source="peso" fullWidth />
                      </SimpleFormIterator>
                    </ArrayInput>
                </Paper>
              </Grid>
            </Grid>
        </SimpleForm>
      </Edit>
    )

}

export const PesadorName = props => {
  const { record } = props;

  return (
    <Typography style={{ fontSize: 20 }}>
      Pesado por:{" "}
      {record.pesadorNombre
        ? record.pesadorNombre
        : "No se tiene informacion sobre el pesador"}
    </Typography>
  );
};



// WEBPACK FOOTER //
// ./src/components/IngresoGrandesGeneradores/IngresoGrandesGeneradoresEditComponent.js